module.exports = __webpack_public_path__ + "static/6357376f735fa7039db2eab7ed7fd3035913022e1a15fd386952ff6a627a9df9-0ea4f00ec01e6868db4d894ff216ea43.png";